import { LEGAL, LEGAL_UPDATED, COMPANY } from "../content/legal";
import { useSeo } from "../lib/seo";
import { PublicHeader, PublicFooter } from "../components/PublicShell";
import { Mail, Clock, MapPin } from "lucide-react";

const PATHS = { terms: "/terms", privacy: "/privacy", refund: "/refund-policy", disclaimer: "/medical-disclaimer", clinical: "/clinical-agreement" };

export function LegalPage({ doc }) {
  const d = LEGAL[doc];
  useSeo({ title: `${d.title} | DentiCision`, description: d.intro.slice(0, 160), path: PATHS[doc] });
  return (
    <div className="min-h-screen bg-white" data-testid={`legal-${doc}-page`}>
      <PublicHeader />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
        <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-[#0B2545]">{d.title}</h1>
        <p className="text-xs text-slate-500 mt-3">Last updated: {LEGAL_UPDATED}</p>
        <p className="text-slate-700 mt-6 leading-relaxed">{d.intro}</p>
        {d.sections.map(([h, paras]) => (
          <section key={h} className="mt-8">
            <h2 className="font-heading text-base md:text-lg font-semibold text-[#0B2545]">{h}</h2>
            {paras.map((p) => <p key={p} className="text-slate-700 text-sm leading-relaxed mt-2">{p}</p>)}
          </section>
        ))}
      </main>
      <PublicFooter />
    </div>
  );
}

export function ContactPage() {
  useSeo({ title: "Contact DentiCision", description: "Contact the DentiCision team — support, billing and partnership enquiries. We reply within 1–3 business days.", path: "/contact" });
  const rows = [
    [Mail, "Email", <a key="e" href={`mailto:${COMPANY.email}`} data-testid="contact-email" className="text-[#1C6FE3] font-medium">{COMPANY.email}</a>],
    [Clock, "Response time", "Within 1–3 business days"],
    [MapPin, "Country", COMPANY.country],
  ];
  return (
    <div className="min-h-screen bg-white" data-testid="contact-page">
      <PublicHeader />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
        <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-[#0B2545]">Contact us</h1>
        <p className="text-slate-600 mt-4">Questions about the platform, your subscription or billing? Subscribers can also send requests from the Support page inside the app.</p>
        <div className="mt-8 rounded-2xl border border-slate-200 divide-y divide-slate-100">
          {rows.map(([Icon, k, v]) => (
            <div key={k} className="flex items-center gap-4 px-6 py-5">
              <Icon className="w-5 h-5 text-[#1C6FE3]" />
              <div><p className="text-xs uppercase tracking-wider text-slate-500">{k}</p><div className="text-slate-800 mt-0.5">{v}</div></div>
            </div>
          ))}
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
